import { useState, useEffect } from "react";

export interface MastodonPost {
  content: string; // HTML string
  url: string;
  createdAt: string;
  cardImage?: string;
}

const ACCOUNT_ID = "109275286552880136";
const INSTANCE = "https://mastodontti.fi";

export function useMastodonPost() {
  const [post, setPost] = useState<MastodonPost | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetch(
      `${INSTANCE}/api/v1/accounts/${ACCOUNT_ID}/statuses?limit=1&exclude_replies=true`
    )
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data: any[]) => {
        if (cancelled) return;
        if (!data || data.length === 0) {
          setError("No posts found");
          return;
        }
        const raw = data[0];
        const isReblog = !!raw.reblog;
        const s = raw.reblog ?? raw;

        let htmlContent = s.content || "";

        if (isReblog) {
          htmlContent = `<div style="font-size: 0.8rem; margin-bottom: 0.5rem; opacity: 0.8;">🔁 Reposted ${
            s.account?.display_name || s.account?.username
          }</div>` + htmlContent;
        }

        if (s.media_attachments && s.media_attachments.length > 0) {
          htmlContent += '<div style="margin-top: 0.5rem; display: flex; flex-direction: column; gap: 0.5rem;">';
          s.media_attachments.forEach((media: any) => {
            if (media.type === "image") {
              htmlContent += `<img src="${media.url}" alt="${
                media.description || ""
              }" style="width: 100%; border-radius: 8px;" />`;
            } else if (media.type === "video" || media.type === "gifv") {
              htmlContent += `<video src="${media.url}" controls poster="${
                media.preview_url || ""
              }" style="width: 100%; border-radius: 8px;"></video>`;
            } else if (media.type === "audio") {
              htmlContent += `<audio src="${media.url}" controls style="width: 100%;"></audio>`;
            }
          });
          htmlContent += "</div>";
        }

        if (s.quote) {
          htmlContent += `<div style="margin-top: 0.5rem; padding: 0.5rem; border: 1px solid rgba(128,128,128,0.3); border-radius: 8px;">
            <div style="font-weight: bold; font-size: 0.9em; margin-bottom: 0.25rem;">${
              s.quote.account?.display_name || s.quote.account?.username
            }</div>
            ${s.quote.content}
          </div>`;
        }

        setPost({
          content: htmlContent,
          url: raw.url,
          createdAt: raw.created_at,
          cardImage: s.card?.image ?? undefined,
        });
      })
      .catch((err) => {
        if (!cancelled) setError(err.message ?? "Failed to load");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { post, loading, error };
}
